<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      d="M14.0161 11.1223L20.4378 3.50049H18.9161L13.3401 10.1184L8.88659 3.50049H3.75L10.4846 13.5079L3.75 21.5005H5.27182L11.1602 14.5118L15.8634 21.5005H21L14.0157 11.1223H14.0161ZM11.9317 13.5961L11.2494 12.5995L5.82016 4.6702H8.15759L12.539 11.0694L13.2214 12.0659L18.9168 20.384H16.5793L11.9317 13.5964V13.5961Z"
      fill="white"
    />
  </svg>
</template>
